import React, { Component } from 'react'

export default class dAppInfo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            passwordKey: '',
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        let { passwordKey } = this.state
        return (
            <div className="dapp-info">
                <div className="dapp-info__list">
                    <h3>{this.translation['dApp info']}</h3>
                    <div className="dapp-info__list-item">
                        <p>Eth address</p>
                        <p>0xbb9bc244d798123fde783fcc1c72d3bb8c189413</p>
                    </div>
                    <div className="dapp-info__list-item">
                        <p>{this.translation['Key']}</p>
                        <p>testuserraa123</p>
                    </div>
                </div>
                <div className="dapp-info__form">
                    <input
                        className="dapp-info__input"
                        placeholder={
                            this.translation['Set a password for the key']
                        }
                        value={passwordKey}
                        onChange={event => {
                            this.changePasswordKey(event)
                        }}
                    />
                    <button className="dapp-info__button">
                        {this.translation['Send']}
                    </button>
                </div>
            </div>
        )
    }

    changePasswordKey = event => {
        this.setState({
            passwordKey: event.target.value,
        })
    }
}
